module.exports = __webpack_public_path__ + "static/media/Calendar.c98f5340.svg";